import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import adminService from '../../services/adminService';
import styles from './AdminLoginPage.module.css';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Same reason as AdminDashboardPage: #root flex-centres the wrapper, so the
  // page bg only renders inside the centred box. Painting body bg dark fills
  // the rest of the viewport.
  useEffect(() => {
    const prevBg = document.body.style.background;
    document.body.style.background = '#0b1424';
    return () => { document.body.style.background = prevBg; };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    const result = await adminService.login({ email, password });
    setSubmitting(false);
    if (result.success) {
      navigate('/admin/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.glowOne} />
      <div className={styles.glowTwo} />
      <form className={styles.card} onSubmit={onSubmit}>
        <div className={styles.brand}>
          <div className={styles.brandIcon}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2 L2 7 L12 12 L22 7 Z" />
              <path d="M2 17 L12 22 L22 17" />
              <path d="M2 12 L12 17 L22 12" />
            </svg>
          </div>
          <div>
            <h1 className={styles.title}>Nodel Admin</h1>
            <p className={styles.subtitle}>Internal use only</p>
          </div>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <label className={styles.field}>
          <span className={styles.label}>Email</span>
          <input
            className={styles.input}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            placeholder="you@nodel.co.za"
            required
          />
        </label>

        <label className={styles.field}>
          <span className={styles.label}>Password</span>
          <input
            className={styles.input}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            placeholder="••••••••"
            required
          />
        </label>

        <button className={styles.button} type="submit" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>

        <div className={styles.footer}>
          Restricted access · authorised personnel only
        </div>
      </form>
    </div>
  );
}
